// @flow
import React, { type Node, useEffect } from 'react';

import useShopCart from './useShopCart';
import ShopCartContext from './ShopCartContext';


/**
 *  Инициализация корзины магазина
 *  Зависит от SettingsDataProvider (использует id корзины из контекста)
 */

type Props = {
  pathname?: string,
  children: Node,
}

const CartInit = ({ pathname, children }: Props) => {
  const value = useShopCart();
  const [, cartActions] = value;

  // обновление корзины при переходе по ссылкам внутри магазина
  useEffect(() => {
    if (pathname && /^\/shop/.test(pathname)) {
      cartActions.handlePeriodicUpdate();
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ShopCartContext.Provider value={value}>
      {children}
    </ShopCartContext.Provider>
  );
};

export default CartInit;
